import map from 'lodash/map';
import { getLatestDate } from '../common';
import moment from 'moment';

const FORTELLIS_ADMIN = 'Fortellis Admin';

export const mapLocationsToTable = (subscribedLocations, allLocations,isBulkSubscribed) => {
  let locations = [];
  subscribedLocations &&
    subscribedLocations.length &&
    subscribedLocations.forEach((subscription) => {
      allLocations &&
        allLocations.length &&
        allLocations.forEach((locationObj) => {
          if (
            (isBulkSubscribed &&
              subscription.entityId === locationObj.entityId &&
              !locations
                .map((loc) => loc.entityId)
                .includes(locationObj.entityId)) ||
            (!isBulkSubscribed &&
              ((!subscription.entitycmfNumber &&
                subscription.entityId === locationObj.entityId) ||
                (subscription.entitycmfNumber === locationObj.cmfNumber &&
                ( subscription.storeId === locationObj.storeId || subscription.orgUnitId === locationObj.storeId)
                )
                ))
          ) {
            let address = locationObj.addresses || [];
            let fullAddress =
              address[0] && address[0].streetAddress + ', ' + address[0].city;
            locations.push({
              location: locationObj.partyName,
              address: fullAddress,
              cmfNumber: subscription?.entitycmfNumber || 'N/A',
              subscribedOn: subscription.subscribedOn ? subscription.subscribedOn : subscription.lastUpdatedOn || subscription.lastUpdated ,
              entityId: subscription?.entityId
            });
          }
        });
    });
  return locations;
};

const item = ({subscription, solutionSubscriptionInfo, isBulkSubscribed, index}) => {
  return {
    appName: solutionSubscriptionInfo[index]?.overview?.name || solutionSubscriptionInfo[index].displayName,
    location: subscription?.length,
    publisher: solutionSubscriptionInfo[index]?.overview?.publisherName || solutionSubscriptionInfo[index].orgName,
    subscribedOn: getLatestDate(subscription),
    solutionData: solutionSubscriptionInfo[index],
    subscriptionData: subscription,
    method: isBulkSubscribed ? FORTELLIS_ADMIN  : (solutionSubscriptionInfo[index]?.activateOnly!==false ? 'Activation' : 'Subscription'),
    isBulkSubscribed: isBulkSubscribed,
    rowHeight: 52,
    solutionLogo: solutionSubscriptionInfo[index]?.overview?.solutionLogo,
    orgId: solutionSubscriptionInfo[index]?.orgId,
    appId: solutionSubscriptionInfo[index]?.id
  }
}

export const createCSVData = (subscriptionData, inActiveBulkSubscriptions, solutionSubscriptionInfo, allLocations, status) => {
  let subscriptions = [];
  map(subscriptionData, (subscription, index) => {
    let  isBulkSubscribed = subscription.filter(sub => sub.isBulkSubscribed ).length>0;
    if(solutionSubscriptionInfo[index]){
      subscriptions.push(item({subscription, solutionSubscriptionInfo, isBulkSubscribed, index}));
    }
  });

  if(inActiveBulkSubscriptions){
    map(inActiveBulkSubscriptions, (subscription, index) => {
      if(solutionSubscriptionInfo[index]){
        subscriptions.push(item({subscription, solutionSubscriptionInfo, isBulkSubscribed: true, index}));
      }
    });
  }

  let subscriptionsForReport = [[,,,,,,,,,]];
  subscriptions?.map(subscription => {
    subscription?.subscriptionData?.map(data => {
        let locationData = mapLocationsToTable([data], allLocations)?.[0];
        let subscribedOn = locationData?.subscribedOn;
        subscriptionsForReport.push(csvData({subscription, locationData, data, subscribedOn, status}));
    })
  })

  return subscriptionsForReport;
}

export const csvData = ({
    subscription: {
      appName,
      method,
      publisher
    } = {}, 
    locationData: {
      location,
      address,
      cmfNumber
    } = {}, 
    data, 
    subscribedOn, 
    status
  }) => {
    const DATE_FORMAT = 'MM/DD/YYYY HH:mm:ss';
    return [
      formatString(appName),
      formatString(method),
      formatString(publisher), 
      formatString(location) || 'NA',
      formatString(address) || 'NA',
      cmfNumber || 'NA',
      data?.entityId,
      subscribedOn ? moment(subscribedOn).format(DATE_FORMAT).trim() : 'NA',
      status,
    ]
}

const formatString = string => {
  return string?.replace(/#|,/g,'');
}
